import Work1 from '../Assets/images/PNG/How_It_Work/work_Img1.png'
import Work2 from '../Assets/images/PNG/How_It_Work/work_Img2.png' 
import Work3 from '../Assets/images/PNG/How_It_Work/work_Img3.png' 

export const work_Data = [
    {
        id: 1,
        title: 'Pick a CertiForm',
        description: 'Quickly find the perfect form for your needs from our library of commercial insurance proposal forms, segmented by line of business and regularly updated to meet industry standards.',
        image: `${Work1}` ,
    },
    {
        id: 2,
        title: 'Share with Client',
        description: 'Effortlessly generate and share forms with your clients through our user-friendly dashboard, keep track of progress with real-time notifications, and view  completed form with ease',
        image:`${Work2}`  ,
        marginTop:"150px"
    },
    {
        id: 3,
        title: 'Track and Manage',
        description: 'Easily manage and track your clients form applications, ',
        image: `${Work3}` ,
        marginTop:"300px"
    },

]